import { render, staticRenderFns } from "./TaskItem.vue?vue&type=template&id=18347101&scoped=true"
import script from "./TaskItem.vue?vue&type=script&lang=js"
export * from "./TaskItem.vue?vue&type=script&lang=js"
import style0 from "./TaskItem.vue?vue&type=style&index=0&id=18347101&prod&lang=less"
import style1 from "./TaskItem.vue?vue&type=style&index=1&id=18347101&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18347101",
  null
  
)

export default component.exports